import { AUTH_LOCAL_STORAGE_KEY } from "../../app/modules/auth";

const API_URL = process.env.REACT_APP_FETCH_API_URL;

const requestOptions: any = {
  method: "GET",
  redirect: "follow",
};
const requestPostOptions: any = {
  method: "POST",
  redirect: "follow",
};

export interface GetBlendersType {
  id: string;
  title: string;
  version_no: string;
  media_url: string | null;
  description: string | null;
}
export const getBlenders = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-blenders`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetBoardsType {
  id: string;
  title: string;
  version_no: string;
  media_url: string | null;
  description: string | null;
}
export const getBoards = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-boards`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};
export interface GetCategoriesType {
  id: string;
  name: string;
}
export const getCategories = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-categories`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};
export interface GetDiagnosisType {
  id: string;
  name: string;
}
export interface GetContractOwnerType {
  id: string;
  name: string;
}
export const getDiagnosis = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-diagnosis`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getMachineServices = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-machine-service`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getOperations = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-operations`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getMarketings = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-marketings`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getMarketingMaterials = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-marketing-materials`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};
export const getIssueReported = async () => {
  const result = await fetch(
    `${API_URL}/api/log-jobs/issue-reporteds`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};
export const getContractOwner = async () => {
  const result = await fetch(
    `${API_URL}/api/log-jobs/contract-owners`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetFlavorsType {
  name: string;
  flavor: string;
}
export const getFlavors = async () => {
  const result = await fetch(`${API_URL}/api/log-jobs/flavors`, requestOptions);
  const data = await result.json();
  return data.data ?? [];
};
export interface GetTubeShieldsType {
  id: string;
  name: string;
  media_url: string | null;
  description: string | null;
}
export const getTubeShields = async () => {
  const result = await fetch(
    `${API_URL}/api/log-jobs/tube-shields`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetCupHoldersType {
  id: string;
  title: string;
  media_url: string | null;
  description: string | null;
}
export const getCupHolders = async () => {
  const result = await fetch(
    `${API_URL}/api/log-jobs/cup-holders`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetIssueReportedType {
  id: string;
  name: string;
}

// Define the StatusOfSanitizer type
type StatusOfSanitizer = "LOW" | "MEDIUM" | "HIGH";

// Define the CustomerSatisfaction type
type CustomerSatisfaction = "EXCELLENT" | "GOOD" | "AVERAGE" | "POOR";

// Define the Cleanliness type
type Cleanliness = "CLEAN" | "MODERATE" | "DIRTY";

// Define the TrafficRate type
type TrafficRate = "HIGH" | "MEDIUM" | "LOW";

// Define the StaffEnthusiasm type
type StaffEnthusiasm = "HIGH" | "MEDIUM" | "LOW";

// Define the Status type
export type LogJobStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "CANCELLED";

// Define the MarketingMaterialsObjectType interface
interface MarketingMaterialsObjectType {
  id: string;
  name: string;
  quantity: number;
}

// Define the LogJobsObjectType interface
interface LogJobsObjectType {
  id: string;
  uuid?: string;
  jobType: string;
  locationId: string;
  dateAndTime: string;
  uploadImagesOrVideos?: Media[];
  machineSerialNumber?: string;
  machineName?: string;
  actionItems: string;
  additionalComments: string;
  createdById: string;
  createdAt: Date;
  updatedById?: string;
  updatedAt?: Date;
  customerSatisfaction?: CustomerSatisfaction;
  cleanliness?: Cleanliness;
  trafficRate?: TrafficRate;
  staffEnthusiasm?: StaffEnthusiasm;
  status: LogJobStatus;
  closingDateAndTime?: string;
  travelingStartTime?: string;
  travelingEndTime?: string;
  workStartTime?: string;
  travelTime?: number;
  sanitizerStatus?: StatusOfSanitizer;
  marketingMaterials?: MarketingMaterialsObjectType[];
}

// Define the Ticket interface
interface Ticket {
  id: number;
  hashId: string;
  uuid: string;
  status: string;
  ticketType: string;
  locationName: string;
  address: string;
  issuesReported: any[];
  issueReportedOtherInput: string;
  machineServices: any[];
  machineServiceOtherInput: string;
  operations: any[];
  operationOtherInput: string;
  travelingStartTime: Date | null;
  travelingEndTime: Date | null;
  workStartTime: Date | null;
  workEndTime: Date | null;
  machineId: string;
}

// Define the Location interface
interface Location {
  name: string;
  id: number;
  address: string;
  city: string;
  workOrderPdf: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
  hasWifiExtender: boolean;
  hasSmoodiRouter: boolean;
  hasPressurePump: boolean;
  hasPressureTank: boolean;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  distributorName: string;
  wifiCredentials: { name: string; password: string };
}

// Define the Machine interface
interface Machine {
  id: number;
  name: string;
  serialNumber: string;
  isPolyFuses: boolean;
  blenderId: string;
  boardId: string;
  cupHolderId: string;
  tubeShieldId: string;
  machineStatusId: string;
  softwareVersion: string;
  macAddress: string;
  hardwareVersion: string;
  lastFilterReplacedAt: string;
  lastHeartbeatAt: string;
  lastSanitizerReplacedAt: string;
  mechanicalHardwareNote: string;
  sanitizerLevel: string;
}

// Define the FlavorPrice interface
interface FlavorPrice {
  price: number;
  flavor: string;
  isActive?: boolean;
}

// Define the GetLogJobByIdResponse interface
export interface GetLogJobByIdResponseType {
  job: LogJobsObjectType;
  tickets: Ticket[];
  location: Location;
  machines: Machine[];
  flavorPrices: FlavorPrice[];
}
export const getLogJobById = async (id: string) => {
  try {
    let authToken = "";
    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    if (lsValue) {
      const user = JSON.parse(lsValue);
      authToken = user.access_token;
    }

    const authRequestHeader = {
      ...requestOptions,
      headers: { Authorization: `Bearer ${authToken}` },
    };
    const result = await fetch(
      `${API_URL}/api/log-jobs/${id}`,
      authRequestHeader,
    );
    if (result.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
    }
    const data = await result.json();
    return data.data ?? null;
  } catch (e) {
    console.log(e);
  }
};

export interface InstallationJobType {
  status: string;
  locationId: string;
  locationName: string;
  locationAddress: string;

  locationNumber?: string;
  workOrderPdf?: string;
  hasMachineSetupBeenCompleted: boolean;
  machines: {
    id: string;
    serialNumber: string;
    currentMachineName: string;
    newMachineName: string;
    isPolyfuses: boolean;
    boardId: string;
    cupHolderId: string;
    blenderId: string;
    tubeShieldId: string | null;
    deploymentDate: Date;
    made4Smoothies: boolean;
    passedSanitizerTest: boolean;
    getStatusPassed: boolean;
    waterLevelCalibratedWithScale: boolean;
    filterType: string;
    machineNotes: string;
    ticket: {
      ticketNumber: number;
      id: string;
      type: string;
      issueReported: string[];
      otherIssueReported: string;
      recommandedServices: string[];
      otherServices: string;
      status: string;
      media: {
        name: string;
        url: string;
        type: string;
      }[];
      comments: string;
    } | null;
  }[];
  headerType: string | null;
  videoUuid: string | null;
  contractOwner: string;
  marketingMaterials: string[];
  flavorPrice: {
    flavor: string;
    price: number;
    is_active: boolean;
  }[];
  hasSmoodiRouter: boolean;
  hasWifiExtender: boolean;
  hasPressurePump: boolean;
  hasPressureTank: boolean;
  customerSecondContact: boolean;
  secondContactName: string;
  secondContactRole: string;
  secondContactPhone: string;
  secondContactEmail: string;
  secondContactPhoneType: string | null;
  customerMarketingContact: boolean;
  marketingContactName: string;
  marketingContactRole: string;
  marketingContactPhone: string;
  marketingContactEmail: string;
  marketingContactPhoneType: string | null;
  storeManagerContact: boolean;
  storeManagerContactName: string;
  storeManagerContactPhone: string;
  storeManagerContactEmail: string;
  storeManagerContactPhoneType: string | null;
  customerItContact: boolean;
  itContactName: string;
  itContactRole: string;
  itContactPhone: string;
  itContactEmail: string;
  itContactPhoneType: string | null;
  customerServiceContact: boolean;
  serviceContactName: string;
  serviceContactRole: string;
  serviceContactPhone: string;
  serviceContactEmail: string;
  serviceContactPhoneType: string | null;
  simCardLast4digits: string | null;
  uploadImagesOrVideos: any;
  notes: {
    categoryId: string;
    note: string;
  }[];
}

export interface GetInstallationJobByIdResponseType {
  isSuccess: boolean;
  message: string;
  data: InstallationJobType;
}
export const getInstallationJobById = async (id: string) => {
  try {
    const result = await fetch(`${API_URL}/api/installation-jobs/${id}`);
    if (result.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
    }
    const data = await result.json();
    return data.data ?? null;
  } catch (error) {
    console.error("Error fetching installation job:", error);
    return null;
  }
};
export interface GetLogJobResponseType {
  job: LogJobsObjectType;
  location: Location;
  flavorPrices: FlavorPrice[];
}
export const getLogJob = async (id: string) => {
  try {
    let authToken = "";
    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    if (lsValue) {
      const user = JSON.parse(lsValue);
      authToken = user.access_token;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const result = await fetch(`${API_URL}/api/log-jobs/${id}/basic`, {
      method: "GET",
      headers,
    });

    if (result.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
      return;
    }

    const data = await result.json();
    return data.data ?? null;
  } catch (e) {
    console.error(e);
    return null;
  }
};
export interface GetLogJobMachinesResponseType {
  machines: Machine[];
}
export const getMachineList = async (id: string) => {
  try {
    let authToken = "";
    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    if (lsValue) {
      const user = JSON.parse(lsValue);
      authToken = user.access_token;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const result = await fetch(`${API_URL}/api/log-jobs/${id}/machines`, {
      method: "GET",
      headers,
    });
    if (result.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
      return;
    }

    const data = await result.json();
    return data.data ?? null;
  } catch (e) {
    console.error(e);
    return null;
  }
};
export interface GetLogJobMachineDetailResponseType {
  tickets: Ticket[];
}
export const getMachineDetail = async (id: string) => {
  try {
    let authToken = "";
    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
    if (lsValue) {
      const user = JSON.parse(lsValue);
      authToken = user.access_token;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };

    const result = await fetch(`${API_URL}/api/log-jobs/${id}/machineDetail`, {
      method: "GET",
      headers,
    });
    if (result.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
      return;
    }

    const data = await result.json();
    return data.data ?? null;
  } catch (e) {
    console.error(e);
    return null;
  }
};
// Define the Media type
interface Media {
  name: string;
  content: string;
}

// Define the UpdateSiteVisitationTicketInput type
interface UpdateSiteVisitationTicketInput {
  id: string;
  diagnosis: string[];
  diagnosisOther?: string;
  machineServicesDone: string[];
  machineServicesDoneOther?: string;
  newBlenderId: string;
  newBoardId: string;
  newMachineId: string;
  oldMachineShiftToLocationId?: string;
  replaceFilter?: boolean;
  replaceSanitizer?: boolean;
  replaceNewTubeDoors1mmShorter?: boolean;
}

// Define the UpdateSiteVisitationInput type
interface UpdateSiteVisitationInput {
  tickets?: UpdateSiteVisitationTicketInput[];
  operations: string[];
  machines: {
    id: string;
    blenderId: string;
    tubeDoorId: string;
    hasPolyfuses: boolean;
    made4Smoothies: boolean;
    cleanlinessCheck: boolean;
    getStatusPassed: boolean;
    flowmeterActivated: boolean;
    waterLevelCalibratedWithScale: boolean;
  }[];
  marketingMaterials: string[];
  sanitizerLevel: StatusOfSanitizer;
  flavorPrices: {
    flavor: string;
    price: number;
  }[];
  smoothieSetupMedia: Media[];
  marketingMaterialPresent: Media[];
}
export const updateJob = async (
  id: string,
  jobData: UpdateSiteVisitationInput,
) => {
  const result = await fetch(`${API_URL}/api/log-jobs/${id}`, {
    ...requestPostOptions,
    body: JSON.stringify(jobData),
  });
  const data = await result.json();
  return data;
};

export const updateJobStatus = async (
  id: string,
  jobType: string,
  date: string,
) => {
  const result = await fetch(`${API_URL}/api/log-jobs/${id}/updateStatus`, {
    ...requestPostOptions,
    body: JSON.stringify({ jobType, date }),
  });
  const data = await result.json();
  return data;
};

export class UploadImagesOrVideosObject {
  imageOfFullSmoodiSetUp?: string[];
  setupFreezerDoorPhoto?: string[];
  machineBackPhoto?: string[];
  machineEntranceViewPhoto?: string[];
  storeWalkthroughVideo?: string[];
}
export type UploadImagesOrVideos = string[] | UploadImagesOrVideosObject;
export class MachineTicketInput {
  id?: string;
  type?: string;
  issueReported?: string[];
  otherIssueReported?: string;
  recommandedServices?: string[];
  otherServices?: string;
  status?: string;
  media?: { name: string; url: string }[];
  comments?: string;
}

export class MachineInput {
  id?: string;
  serialNumber?: string;
  currentMachineName?: string;
  newMachineName?: string;
  deploymentDate?: string;
  made4Smoothies?: boolean;
  passedSanitizerTest?: boolean;
  getStatusPassed?: boolean;
  waterLevelCalibratedWithScale?: string;
  filterType?: string;
  machineNotes?: string;
  ticket?: MachineTicketInput;
}
export class FlavorPriceInput {
  flavor?: string;
  price?: number;
  is_active?: boolean;
}

export class UpdateInstallationJobInput {
  locationId?: string;
  locationName?: string;
  locationAddress?: string;

  machines?: MachineInput[];
  videoUuid?: string;
  headerType?: string;
  contractOwner?: string;

  marketingMaterials?: string[];
  flavorPrice?: FlavorPriceInput[];
  hasSmoodiRouter?: boolean;
  hasWifiExtender?: boolean;
  hasPressurePump?: boolean;
  hasPressureTank?: boolean;

  // --- Contacts ---
  customerSecondContact?: boolean;
  secondContactName?: string;
  secondContactRole?: string;
  secondContactPhone?: string;
  secondContactEmail?: string;
  secondContactPhoneType?: string;
  customerMarketingContact?: boolean;
  marketingContactName?: string;
  marketingContactRole?: string;
  marketingContactPhone?: string;
  marketingContactEmail?: string;
  marketingContactPhoneType?: string;
  customerItContact?: boolean;
  storeManagerContactName?: string;
  storeManagerContactRole?: string;
  storeManagerContactPhone?: string;
  storeManagerContactEmail?: string;
  storeManagerContactPhoneType?: string;
  customerServiceContact?: boolean;
  itContactName?: string;
  itContactRole?: string;
  itContactPhone?: string;
  itContactEmail?: string;
  itContactPhoneType?: string;
  storeManagerContact?: boolean;
  serviceContactName?: string;
  serviceContactRole?: string;
  serviceContactPhone?: string;
  serviceContactEmail?: string;
  serviceContactPhoneType?: string;
  // --- Upload Images/Videos (JSONB field) ---
  uploadImagesOrVideos?: UploadImagesOrVideos;

  // --- Additional Notes --
  additionalComments?: string;
  additionalNoteCategoryId?: string;
}

export const updateInstallationJob = async (
  id: string,
  jobData: UpdateInstallationJobInput,
) => {
  const result = await fetch(`${API_URL}/api/installation-jobs/${id}`, {
    ...requestPostOptions,
    body: JSON.stringify(jobData),
  });
  const data = await result.json();
  return data;
};

export const completeInstallationJob = async (
  id: string,
  jobData: UpdateInstallationJobInput,
) => {
  const result = await fetch(
    `${API_URL}/api/installation-jobs/${id}/complete-installation`,
    {
      ...requestPostOptions,
      body: JSON.stringify(jobData),
    },
  );
  const data = await result.json();
  return data;
};

interface AttachMediaAndCompleteInstallationJobInput {
  uploadImagesOrVideos: UploadImagesOrVideos;
  notes?: { categoryId: string; note: string }[];
}
export const attachMediaAndCompleteInstallationJob = async (
  id: string,
  input: AttachMediaAndCompleteInstallationJobInput,
) => {
  const result = await fetch(
    `${API_URL}/api/installation-jobs/${id}/attach-media-and-complete-installation`,
    {
      ...requestPostOptions,
      body: JSON.stringify(input),
    },
  );
  const data = await result.json();
  return data;
};

export interface GetAvailableMachinesForReplaceType {
  id: string;
  location_name: string;
  serial_number: string;
  machine_name: string;
  location_id: string;
  site_status: boolean;
  machine_status: string;
  city: string;
}
export const getAvailableMachinesForReplace = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-replace-machines`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetLocationsType {
  id: string;
  name: string;
  address: string;
  city: string;
  contactName: string;
  location_number?: string;
  video_for_header?: string;
  header_type?: string;
  sim_card_last_4_digits?: string;
  contract_owner_id?: string;

  has_pressure_pump?: boolean;
  has_pressure_tank?: boolean;
  has_smoodi_router?: boolean;
  has_wifi_extender?: boolean;
  flavor_prices?: { flavor: string; price: number; is_active: boolean }[];
  customer_second_contact?: boolean;
  second_contact_name?: string;
  second_contact_phone_number?: string;
  second_contact_email?: string;
  second_contact_name_role?: string;
  type_of_second_contact_phone_number?: string;

  customer_marketing_contact?: boolean;
  marketing_contact_name?: string;
  marketing_contact_phone_number?: string;
  marketing_contact_email?: string;
  marketing_contact_name_role?: string;
  type_of_marketing_contact_phone_number?: string;

  customer_it_contact?: boolean;
  it_contact_name?: string;
  it_contact_phone_number?: string;
  it_contact_email?: string;
  it_contact_name_role?: string;
  type_of_it_contact_phone_number?: string;

  customer_service_contact?: boolean;
  service_contact_name?: string;
  service_contact_phone_number?: string;
  service_contact_email?: string;
  service_contact_name_role?: string;
  type_of_service_contact_phone_number?: string;

  store_manager_contact?: boolean;
  store_manager_contact_name?: string;
  store_manager_contact_phone_number?: string;
  store_manager_contact_email?: string;
  type_of_store_manager_contact_phone_number?: string;
  workOrderPdf?: string;
}

export const updateMachineName = async (machineId: string, newName: string) => {
  const result = await fetch(
    `${API_URL}/api/log-jobs/${machineId}/update-name`,
    { ...requestPostOptions, body: JSON.stringify({ name: newName }) },
  );
  const data = await result.json();
  return data;
};
export const getLocations = async () => {
  const result = await fetch(
    `${API_URL}/api/tickets/get-locations`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface GetLedRingsType {
  id: string;
  name: string;
  media_url: string | null;
  description: string | null;
}

export const getLedRings = async () => {
  const result = await fetch(
    `${API_URL}/api/installation-jobs/led-rings`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getLocationForInstallation = async () => {
  const result = await fetch(
    `${API_URL}/api/installation-jobs/get-locations`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export const getVideo = async () => {
  const result = await fetch(
    `${API_URL}/api/installation-jobs/videos`,
    requestOptions,
  );
  const data = await result.json();
  return data.data ?? [];
};

export interface SignedUrlInputItem {
  file_type: string;
  file_name: string;
  folder_name: string;
}

export interface GenerateMultiSignedUrlsResponseItem {
  url: string;
  file_name?: string;
  file_type?: string;
  folder_name?: string;
}

export const generateMultiSignedUrls = async (
  signedUrlInput: SignedUrlInputItem[],
) => {
  try {
    const response = await fetch(
      `${API_URL}/api/installation-jobs/generate-multi-signed-urls`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ signed_url_input: signedUrlInput }),
      },
    );

    if (response.status === 401) {
      localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
      window.location.href = "/auth/login";
      return [] as GenerateMultiSignedUrlsResponseItem[];
    }

    const data = await response.json();
    // Support multiple shapes: raw array, { data }, or { data: { urls } }
    const urls = Array.isArray(data)
      ? data
      : data?.data?.urls || data?.data || [];
    return urls as GenerateMultiSignedUrlsResponseItem[];
  } catch (error) {
    console.error("Failed to generate multi-signed URLs", error);
    return [] as GenerateMultiSignedUrlsResponseItem[];
  }
};

export interface ReplaceMachineInput {
  currentMachineId: string;
  newMachineId: string;
  oldMachineShiftToLocationId?: string;
  convertToLabTicket?: boolean;
}

export const replaceMachine = async (
  id: string,
  machineData: ReplaceMachineInput,
) => {
  const result = await fetch(`${API_URL}/api/log-jobs/${id}/replace-machine`, {
    ...requestPostOptions,
    headers: {
      "Content-Type": "application/json",
      ...requestPostOptions.headers,
    },
    body: JSON.stringify(machineData),
  });
  const data = await result.json();
  return data;
};

export interface InstallationJobMachineSetupMachineInput {
  id: string;
  serialNumber: string;
  currentMachineName: string;
  newMachineName: string;
  deploymentDate: string;
}

export interface InstallationJobMachineSetupInput {
  locationId: string;
  machines: InstallationJobMachineSetupMachineInput[];
}

export const installationJobMachineSetup = async (
  id: string,
  machineData: InstallationJobMachineSetupInput,
) => {
  let authToken = "";
  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (lsValue) {
    const user = JSON.parse(lsValue);
    authToken = user.access_token;
  }

  const result = await fetch(
    `${API_URL}/api/installation-jobs/${id}/setup-machine`,
    {
      ...requestPostOptions,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(machineData),
    },
  );
  const data = await result.json();
  return data;
};

export const getSignedUrl = async (fileUrl: string) => {
  const result = await fetch(`${API_URL}/api/media/${fileUrl}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await result.json();
  return data;
};
